import { Lead } from './lead.model';
import { PartnerQuoteRequest } from './partner-quote-request.model';

import { Partner } from './partner.model';

export interface Quote {
  id: number;
  leadAssignment: PartnerQuoteRequest;
  leadAssignmentId: number;
  partner: Partner;
  declaredAmount: number;
  pdf: string;
  pdfPreview: string;
  accommodationIncluded: boolean;
  flightIncluded: boolean;
  isFinanceable: boolean;
  hasTransportToClinic: boolean;
  internalNote?: string;
  createdAt: string;
  updatedAt: string;
  status: QuoteStatusEnum;
  lead: Lead;
  canReview?: boolean;
  interestAt: string | null;
  healthDataRestricted?: boolean;
  /** Full name of the clinic user who created the quote; null/undefined for legacy quotes. */
  createdByName?: string | null;
}

export enum QuoteStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
